import { useEffect, useState } from "react";
import Select from 'react-select';

const ScoreModal = ({ show, onClose, onSave, playerVs, winner, winnerHoles, type }) => {
    const [thru, setThru]         = useState("");
    const [score, setScore]       = useState("");
    const [leaderId, setLeaderId] = useState("");

    useEffect(() => {
        if (!show) { setThru(""); setScore(""); setLeaderId(""); return; }
        if (winner) {
            const hole = winnerHoles?.[0];
            setThru(hole?.Hole ?? "");
            setScore(winner.Point ?? "");
            setLeaderId(winner.User1ID ?? "");
        }
    }, [show, winner, winnerHoles]);

    const handleSave = () => {
        if (!leaderId || thru === "" || score === "") {
            swal.fire({ icon: "warning", titleText: "Oops..", text: "Please fill all fields." });
            return;
        }
        onSave({ leaderId: parseInt(leaderId), thru: parseInt(thru), score: parseInt(score) });
    };

    if (!show) return null;

    const singlesOptions = playerVs
        ? [{ ID: playerVs.User1ID, Name: playerVs.User1Name }, { ID: playerVs.User2ID, Name: playerVs.User2Name }]
        : [];
    const doublesOptions = playerVs
        ? [
            { ID: playerVs.User1ID, Name: `${playerVs.User1Name} | ${playerVs.User2Name}` },
            { ID: playerVs.User3ID, Name: `${playerVs.User3Name} | ${playerVs.User4Name}` },
          ]
        : [];
    const options = type === "Singles" ? singlesOptions : doublesOptions;

    return (
        <>
            {/* Backdrop — z-index below modal content but above page */}
            <div
                className="modal-backdrop fade show"
                style={{ zIndex: 1040 }}
                onClick={onClose}
            />
            <div
                className="modal fade show"
                style={{ display: "block", zIndex: 1050 }}
                tabIndex="-1"
                role="dialog"
                onClick={e => e.stopPropagation()}
            >
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Update Score</h5>
                            <button type="button" className="close" onClick={onClose}><span>&times;</span></button>
                        </div>
                        <div className="modal-body grey-background">
                            <div className="kt-portlet margin-t20">
                                <div className="kt-portlet__body">
                                    <div className="form-group row margin-t20">
                                        <label className="col-form-label offset-lg-1 col-lg-2">
                                            {type === "Singles" ? "Player" : "Team"} <span className="text-danger">*</span>
                                        </label>
                                        <div className="col-xl-6 col-lg-8">
                                            {/* <select
                                                className="form-control"
                                                value={leaderId}
                                                onChange={e => setLeaderId(e.target.value)}
                                            >
                                                <option value="">Select {type === "Singles" ? "Player" : "Team"}</option>
                                                {options.map(o => (
                                                    <option key={o.ID} value={o.ID}>{o.Name}</option>
                                                ))}
                                            </select> */}
                                            <Select
                                                className="width-100p"
                                                placeholder={`Select ${type === "Singles" ? "Player" : "Team"}`}
                                                options={(options || []).map(o => ({
                                                    label: o.Name,
                                                    value: o
                                                }))}
                                                value={
                                                    leaderId
                                                        ? (options || [])
                                                            .map(o => ({
                                                                label: o.Name,
                                                                value: o
                                                            }))
                                                            .find(o => o.value.ID == leaderId)
                                                        : null
                                                }
                                                onChange={(selected) => setLeaderId(selected?.value?.ID || "")}
                                            />
                                            <small className="form-text text-muted">Select the leading {type === "Singles" ? "player" : "team"}</small>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-form-label offset-lg-1 col-lg-2">
                                            <strong>Thru Hole Number</strong> <span className="text-danger">*</span>
                                        </label>
                                        <div className="col-xl-6 col-lg-8">
                                            <input
                                                type="number" className="form-control"
                                                value={thru} onChange={e => setThru(e.target.value)}
                                                min={1} max={99}
                                            />
                                            <small className="form-text text-muted">Enter the number of last hole completed</small>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-form-label offset-lg-1 col-lg-2">
                                            <strong>Match Score</strong> <span className="text-danger">*</span>
                                        </label>
                                        <div className="col-xl-6 col-lg-8">
                                            <input
                                                type="number" className="form-control"
                                                value={score} onChange={e => setScore(e.target.value)}
                                                min={0}
                                            />
                                            <small className="form-text text-muted">Enter the score (e.g. 1, 2)</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer margin-tb10">
                            <button type="button" className="btn btn-secondary" onClick={onClose}>Close</button>
                            <button type="button" className="btn btn-primary" onClick={handleSave}>Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ScoreModal;